/* eslint-disable no-case-declarations */
import { Action } from "redux";

import * as FetchActions from "../actions/FetchActions";
import * as ProcessVariableEditorActions from "../actions/ProcessVariablesEditorActions";

export function environmentVariables(state: string[] = [], action: Action): string[] {
    switch (action.type) {
        case FetchActions.RECEIVE_ENVIRONMENT_VARIABLES:
            const receiveAction = action as FetchActions.ReceiveEnvironmentVariablesAction;
            return receiveAction.environmentVariables;
        case ProcessVariableEditorActions.ADDED_ENVIRONMENT_VARIABLE:
            const addAction = action as ProcessVariableEditorActions.AddedNewEnvironmentVariableAction;
            return state.concat(addAction.environmentVariableName);
        default:
            return state;
    }
}
